var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-percent-bar',
    ("dp-percent-bar--state-" + _vm.stateClass) ]},[_c('span',{staticClass:"dp-percent-bar__label"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"dp-percent-bar__indicator",style:(_vm.indicatorStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }